import { authStateService } from "../../../../legacy/services/authentication-service/auth-state/auth-state.service.instance";
import type { IAuthStateService } from "../../../../legacy/services/authentication-service/auth-state/auth-state.service.interface";

import type { GuardCheckResult } from "../types/guard.type";
import type { IAuthGuardService } from "./auth.guard.interface";

export class AuthGuardService implements IAuthGuardService {
  private static instance: AuthGuardService;

  private constructor(private readonly _authStateService: IAuthStateService = authStateService) {}

  static getInstance(): AuthGuardService {
    if (!AuthGuardService.instance) {
      AuthGuardService.instance = new AuthGuardService();
    }
    return AuthGuardService.instance;
  }

  isAuthenticated(): boolean {
    return this._authStateService.isAuthenticated();
  }

  check(): GuardCheckResult {
    return {
      allowed: this.isAuthenticated(),
    };
  }
}

export const authGuardService = AuthGuardService.getInstance();
